'use client';

// import { Button } from '@ahafood/ui/components/button';
import { EmptySearch } from '@ahamove/icons/empty';
// import { useStoreCitySheet } from '@/contexts/store-city-sheet-context';

export type StoreEmptyStateVariant = 'nearby' | 'search';

interface StoreEmptyStateProps {
  /**
   * 'nearby' — user đã chọn địa chỉ nhưng không có cửa hàng nào trong bán kính.
   * 'search' — không có cửa hàng khớp với từ khoá tìm kiếm.
   */
  variant?: StoreEmptyStateVariant;
  /** Từ khoá tìm kiếm, dùng cho variant 'search' để hiển thị trong message. */
  searchText?: string;
}

/**
 * Empty state cho danh sách cửa hàng khi query (có kèm lat/lng) trả về rỗng.
 * KHÔNG fallback về list theo city_id — thay vào đó gợi ý user đổi địa chỉ.
 */
export default function StoreEmptyState({
  variant = 'nearby',
  searchText,
}: StoreEmptyStateProps) {
  // const { openCitySheet } = useStoreCitySheet();

  const isSearch = variant === 'search';
  const title = isSearch
    ? 'Không tìm thấy cửa hàng phù hợp'
    : 'Không có cửa hàng nào gần bạn';
  const subtitle = isSearch
    ? searchText
      ? `Không có cửa hàng nào khớp với "${searchText}" gần vị trí của bạn.`
      : 'Không có cửa hàng nào khớp với tìm kiếm gần vị trí của bạn.'
    : 'Không tìm thấy cửa hàng nào gần vị trí của bạn';

  return (
    <div className="col-span-full flex flex-col items-center justify-center px-6 py-16 text-center">
      <EmptySearch className="size-20 mb-4" />
      <h3 className="text-base font-semibold text-neutral-90">{title}</h3>
      <p className="mt-1 max-w-sm text-sm text-neutral-60">{subtitle}</p>
      {/* <Button
        variant="outline"
        className="mt-4"
        onClick={openCitySheet}
        data-testid="store-empty-change-address"
      >
        Đổi địa chỉ
      </Button> */}
    </div>
  );
}
